export const TARIF_RESET = "TARIF_RESET";
export const TARIF_SET_ERROR = "TARIF_SET_ERROR";
export const TARIF_SET_ITEMS = "TARIF_SET_ITEMS";
export const TARIF_TOGGLE_LOADING = "TARIF_TOGGLE_LOADING";
